import type { ThemeProps as Props } from "models/styles/theme";
import styled from "styled-components/macro";

import { Breadcrumbs } from "components/Breadcrumbs";

export const StyledBreadcrumbs = styled(Breadcrumbs)<Props>`
  margin-bottom: 2rem;
`;
